module.exports = __webpack_public_path__ + "img/025.caf4d5cf.jpg";